module.exports = __webpack_public_path__ + "ea630708659fa11aedc4d625996c90b9.png";